import React, { useMemo } from 'react'

import s from './s.module.css'
import { groupByDay } from './groupByDay'
import TransactionRow from './TransactionRow'
import { formatDate as formatDateUtil } from '~utils/date'
import { Transaction } from '~pages/CardsPage/Cards/Transactions/types'

interface Props {
    onRowClick: (tx: Transaction) => void
    data?: Transaction[]
}

function List({ onRowClick, data }: Props) {
    const dataByDays = useMemo(() => {
        return data?.length ? groupByDay(data) : []
    }, [data])

    return (
        <>
            {dataByDays?.map(item => (
                <>
                    <div data-pointer="transaction_date" className={s.day}>
                        {item.date && formatDateUtil({ date: item.date, formatString: 'dd MMMM yyyy' })}
                    </div>
                    <div className={s.table}>
                        {item.transactions.map(tx => (
                            <TransactionRow key={tx.id} data={tx} onClick={() => onRowClick(tx)} />
                        ))}
                    </div>
                </>
            ))}
        </>
    )
}

export default List
